import Navbar from './Navbar';
import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <>
      <Navbar />
      <main>
        <Outlet /> {/* Çocuk route’ları render eder */}
      </main>
    </>
  );
}

export default Layout;